import { render, staticRenderFns } from "./FileUpload.1.vue?vue&type=template&id=253affd2&scoped=true&"
import script from "./FileUpload.1.vue?vue&type=script&lang=js&"
export * from "./FileUpload.1.vue?vue&type=script&lang=js&"
import style0 from "./FileUpload.1.vue?vue&type=style&index=0&id=253affd2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253affd2",
  null
  
)

export default component.exports